(function () {
  // Scroll-reveal (IntersectionObserver)
  if ("IntersectionObserver" in window) {
    var reveals = document.querySelectorAll(".reveal");
    var revealOptions = {
      threshold: 0.15,
      rootMargin: "0px 0px -100px 0px"
    };
    var revealOnScroll = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
        }
      });
    }, revealOptions);
    reveals.forEach(function (el) {
      revealOnScroll.observe(el);
    });
  }
})();
